module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_0.9f3546fc.png";